import React, { useEffect, useState,useRef } from 'react'
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom'

import styles from "./LoginForm.module.css"
import { BreathAPIs } from '../APIs/BreathAPIs'
import { login, authLogin } from '../Actions/Auth'
import { setAlert } from '../Actions/Alert'
import { connect, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
//import { useNavigate } from 'react-router'
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';

import MFAValidation from './MFAValidation'
import GuestOTPValidation from './GuestOTPValidation'

import BreatheEV_Mobile_Logo from '../Images/logo-mobile.png';
import BreatheEV_Logo from '../Images/logo.png';
import { Image } from 'react-bootstrap'
import Alert from '../BootstrapComponents/Alert';

import { AiOutlineEye,AiOutlineEyeInvisible } from "react-icons/ai"
import { Modal } from "antd";


const LoginForm = ({ login, authLogin, isAuthenticated, setAlert, role}) => {
    
    //const navigate = useNavigate();
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [redirect, setRedirect] = useState('')
    const [inprogress, setInprogress] = useState(false);
    const [breatheAdminInProgress, setbreatheAdminInprogress] = useState(null);
    const [viewBEVUserLoginOptions,setViewBEVUserLoginOptions] = useState(false);
    const [userInfo,setUserInfo] = useState({});
    const [type, setType] = useState('password');
    const [icon, setIcon] = useState(AiOutlineEye);
    const timeoutRef = useRef(null);

    const [is2FAverified, setIs2FAverified] = useState(false);
    const [show2FAModal, setShow2FAModal] = useState(false);
    const [adminUserType, setAdminUserType] = useState(null);
    const [showGuestModal, setShowGuestModal] = useState(false);
    // Defaults to true (shown) until the admin setting loads, matching the
    // rest of the guest flow's "safer default while loading" convention.
    const [guestLoginEnabled, setGuestLoginEnabled] = useState(true);

    const { isLoading } = useSelector(state => state.auth.loading)
    //const {role} = useSelector(state => state.auth.user?.type || "User")

    const loginUser = {
        email: email?.toLocaleLowerCase(),
        password
    }

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const redirectBase64 = searchParams.get('redirect');
    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            const redirectPath = redirectBase64 ? atob(redirectBase64) : '/';
            setRedirect(redirectPath)
        }
    }, [isAuthenticated, isLoading, role])

    useEffect(() => {
        BreathAPIs.getGuestSettings()
            .then(response => {
                if (response?.data?.loginEnabled === false) {
                    setGuestLoginEnabled(false);
                }
            })
            .catch(() => {});
    }, [])

    useEffect(() => {
        const verifyUser = async () => {
            if (is2FAverified) {
                try{
                    setInprogress(true);
                    // const res = await BreathAPIs.BEVUserLogin(loginUser);
                    // setInprogress(false);
                    // if(res.status===200){
                    //     const {type:userType} = res.data.data;
                        if(adminUserType === 'Admin'){
                                setInprogress(true);
                                //redux
                                await login(loginUser);
                                setInprogress(false);
                                setIs2FAverified(false);
                        }
                        else{

                            // setUserInfo(res.data.data);
                            setViewBEVUserLoginOptions(true);
                        }

                        
                    // }else{
                    //     console.log("inside else ", res)
                    //     setInprogress(false);
                    //     setIs2FAverified(false);
                    //     setAlert('Error during login. Please try again.','danger')
                    // }
                }catch(err){
                    
                    setInprogress(false);
                    setIs2FAverified(false);
                    setAlert(err?.response?.data?.errors?.msg ?? 'Error during login. Please try again.', 'danger');
                }finally{
                    setIs2FAverified(false);
                    setInprogress(false);
                    setAdminUserType(null);
                }
                
            }
        };
        verifyUser();
    }, [is2FAverified])

    const onSubmit = async (e) => {
        e.preventDefault()
        try {
            if (email == '' || password == '') {
                setAlert("Enter email and password.", 'danger')
            }
            else {

                if(!email.includes('breathe-ev')){
                    
                    setInprogress(true);
                    //redux
                    await login(loginUser);
                    setInprogress(false);
                }
                else{
                    try{
                        setInprogress(true);
                        const res = await BreathAPIs.BEVUserLogin(loginUser);
                        setInprogress(false);
                        if(res.status===200){
                            const {type:userType} = res.data.data;
                            if(userType === 'Admin'){
                                setAdminUserType('Admin');
                            }else{
                                setUserInfo(res.data.data)
                            }
                            setShow2FAModal(true);
                        }
                    }catch(err){
                        setAdminUserType(null);
                        setInprogress(false);
                        setIs2FAverified(false);
                        setAlert(err?.response?.data?.errors?.msg ?? 'Error during login. Please try again.', 'danger');
                    }
                    
                    // setInprogress(true);
                    // const res = await BreathAPIs.BEVUserLogin(loginUser);
                    // setInprogress(false);
                    // if(res.status===200){
                    //     const {type:userType} = res.data.data;
                    //     if(userType === 'Admin'){
                    //             setInprogress(true);
                    //             //redux
                    //             await login(loginUser);
                    //             setInprogress(false);
                    //     }
                    //     else{

                    //         setUserInfo(res.data.data);
                    //         setViewBEVUserLoginOptions(true);
                    //     }

                        
                    // }
                  

                }
            }

        }
        catch (err) {
            setInprogress(false);
            console.error(err.response.data)
            setAlert(err.response.data.errors.msg,'danger')
        }
        //console.log(loginUser);
    }

    const HandleBEVMemberUserType = async (selectedUserType) => {
        try {
         
            setbreatheAdminInprogress(selectedUserType);
            if(userInfo.type!==selectedUserType){
                const res = await BreathAPIs.updateBEVMemberUserType({...userInfo, type:selectedUserType});
                // setViewBEVUserLoginOptions(false);

            }
            setInprogress(true);
            //redux
            await login(loginUser);
            setInprogress(false);
            setViewBEVUserLoginOptions(false);
            setbreatheAdminInprogress(null);

            
        } catch (error) {
            setViewBEVUserLoginOptions(false);
            setbreatheAdminInprogress(null);
            setAlert('Error ! Please Try Again','danger')
            console.error('Error while updating BEV member user type: ',error);
        }finally{
            setIs2FAverified(false);
        }
    
        // console.log('Mouse down');
      };



    const handleMouseDown = () => {
        
        timeoutRef.current = setTimeout(() => {
            setIcon(AiOutlineEyeInvisible);
            setType('text');
            
        
        }, 100);
    
        // console.log('Mouse down');
      };
    
      const handleMouseUp = () => {
        
        setIcon(AiOutlineEye);
        setType('password')
        clearTimeout(timeoutRef.current);
        // console.log('Mouse up');
      };
    
      useEffect(() => {
        return () => clearTimeout(timeoutRef.current);
      }, []);


    async function auth(){
        const response = await fetch(`${process.env.REACT_APP_API_URL}/oauth/request`,{method:'post'});

        const data = await response.json();
        window.location.href = data.url;
    }

    const loadAppleSDK = () => {
        return new Promise((resolve, reject) => {
            if (window.AppleID) {
                resolve(window.AppleID);
                return;
            }
            const existingScript = document.getElementById('appleid-signin-sdk');
            if (existingScript) {
                existingScript.addEventListener('load', () => resolve(window.AppleID));
                existingScript.addEventListener('error', reject);
                return;
            }
            const script = document.createElement('script');
            script.id = 'appleid-signin-sdk';
            script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
            script.async = true;
            script.onload = () => resolve(window.AppleID);
            script.onerror = reject;
            document.head.appendChild(script);
        });
    };

    async function authApple(){
        try {
            const AppleID = await loadAppleSDK();

            AppleID.auth.init({
                clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                scope: 'name email',
                redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI || window.location.origin,
                usePopup: true,
            });

            const appleResponse = await AppleID.auth.signIn();
            const identityToken = appleResponse?.authorization?.id_token;

            if (!identityToken) {
                setAlert('Sign in with Apple failed. Please try again.', 'danger');
                return;
            }

            const response = await fetch(`${process.env.REACT_APP_API_URL}/oauth/appleauth`, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    identityToken,
                    firstName: appleResponse?.user?.name?.firstName,
                    lastName: appleResponse?.user?.name?.lastName,
                }),
            });
            const data = await response.json();

            if (response.ok && data?.success && data?.token) {
                authLogin(data.token);
                setRedirect('/');
            } else {
                setAlert(data?.message || 'Sign in with Apple failed. Please try again.', 'danger');
            }
        } catch (err) {
            if (err?.error === 'popup_closed_by_user') {
                return;
            }
            console.error('Error during Apple sign in:', err);
            setAlert('Sign in with Apple failed. Please try again.', 'danger');
        }
    }

    function onGuestVerified(token, guestId){
        localStorage.setItem('guestToken', guestId);
        authLogin(token);
        setRedirect('/');
    }

    function handleGuestBack(){
        setShowGuestModal(false);
    }

    //Redirect to dashboard

    if (redirect ) {

        return <Navigate to={redirect}></Navigate>
    }

    return (
        <section className="bg-light py-3 py-md-5 py-xl-8 min-vh-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
                        <div className="mb-5">
                            <div className="text-center mb-4">
                                <Image className={styles['logo']} src={BreatheEV_Logo} alt="" />
                            </div>
                        </div>
                        <div className="card border border-light-subtle rounded-4">
                            <div className="card-body p-3 p-md-4 p-xl-5">
                                {showGuestModal ? (
                                    <GuestOTPValidation
                                        onVerified={onGuestVerified}
                                        onBack={handleGuestBack}
                                    />
                                ) : (
                                <form onSubmit={onSubmit}>
                                    <h5 className={`mb-4 ${styles['login-title']}`}>Login</h5>
                                    <Alert></Alert>
                                    <div className="row gy-3 overflow-hidden">
                                        <div className="col-12">
                                            <div className="form-floating mb-3">
                                                <input className="form-control" disabled={viewBEVUserLoginOptions} readOnly={inprogress ? true : false} type="email" name="email" placeholder='Enter Email' onChange={(e) => { setEmail(e.target.value) }} value={email} required />
                                                <label htmlFor="email" className="form-label">Email</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-floating mb-3" style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                                                
                                                <input className={`form-control ${styles['form-control-pass']}`} disabled={viewBEVUserLoginOptions} readOnly={inprogress ? true : false} type={type} name="password" placeholder='Enter password' onChange={(e) => { setPassword(e.target.value) }} value={password} required />
                                                {/* <i className={styles['pass-view-icon']} onClick={togglePasswordView}>{icon}</i> */}
                                                <div  className={styles['pass-view-icon']} onTouchStart={handleMouseDown}  onTouchEnd={handleMouseUp} onTouchMove={handleMouseUp}   onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp} >{icon}</div>
                                                <label htmlFor="password" className="form-label">Password</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="d-flex justify-content-between">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" value="" name="remember_me" id="remember_me" />
                                                    <label className="form-check-label text-secondary" htmlFor="remember_me">
                                                        Remember me
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            viewBEVUserLoginOptions ?

                                            <>
                                                <div className='col-12'>
                                            <div className="d-grid">
                                            <ButtonCustom
                                                variant={"primary"}
                                                text={"Continue as Admin"}
                                                disabled={inprogress ? true : false}
                                                isLoading={breatheAdminInProgress==='Breathe-Admin'?true:false}
                                                onClick={()=>{HandleBEVMemberUserType('Breathe-Admin')}}
                                                ></ButtonCustom>
                                                </div>
                                        </div>
                                        <p className="text-center">Or</p>
                                         <div className="col-12">
                                             <div className="d-grid">
                                                <ButtonCustom
                                                    variant={"primary"}
                                                    text={"Continue as User"}
                                                    disabled={inprogress ? true : false}
                                                    isLoading={breatheAdminInProgress==='User'?true:false}
                                                    onClick={()=>{HandleBEVMemberUserType('User')}}
                                                    ></ButtonCustom>
                                            </div>
                                        </div>
                                            </>
                                            :
                                            <>
                                        <div className="col-12">
                                            <div className="d-grid">
                                                <ButtonCustom
                                                    variant={"primary"}
                                                    text={"Log in"}
                                                    disabled={inprogress ? true : false}
                                                    isLoading={inprogress}
                                                    onClick={onSubmit}></ButtonCustom>
                                            </div>
                                        </div>
                                        <p className="text-center">Or</p>
                                        <div className={`text-center ${styles['google-sign-in']}`} >
                                            <button type='button' className="btn bsb-btn-2xl btn-outline-primary" onClick={auth}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-google" viewBox="0 0 16 16">
                                                    <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
                                                </svg>
                                                <span className="ms-2 fs-6">Log in with Google</span>
                                            </button>
                                        </div>
                                        {guestLoginEnabled && (
                                            <div className={`col-12 ${styles['guest-sign-in']}`}>
                                                <div className="d-grid">
                                                    <button type='button' className={`btn bsb-btn-2xl ${styles['btn-guest']}`} disabled={inprogress ? true : false} onClick={() => setShowGuestModal(true)}>
                                                        <span className="fs-6">Continue as Guest</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                        {/* <div className={`text-center ${styles['apple-sign-in']}`} >
                                            <button type='button' className={`btn bsb-btn-2xl ${styles['btn-apple']}`} onClick={authApple}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-apple" viewBox="0 0 16 16">
                                                    <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.79-2.128Z"/>
                                                </svg>
                                                <span className="ms-2 fs-6">Sign in with Apple</span>
                                            </button>
                                        </div> */}
                                            </>
                                        }
                                    </div>
                                </form>
                                )}
                            </div>
                        </div>
                        <div className="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-center align-items-center mt-4">
                            <Link className="link-secondary text-decoration-none" to={`${process.env.REACT_APP_BASE_URL}/registration`}>Create new account</Link>
                            <Link to={`${process.env.REACT_APP_BASE_URL}/forgot-password/verify`} className="link-secondary text-decoration-none">Forgot password</Link>
                        </div>
                    </div>
                </div>
            </div>
            {
                show2FAModal && <Modal
                    title="Two-Factor Authentication"
                    open={show2FAModal}
                    onCancel={() => setShow2FAModal(false)}
                    footer={null}
                >
                    <MFAValidation setShow2FAModal={setShow2FAModal} setIs2FAverified={setIs2FAverified} email={email} password={password} />
                </Modal>
            }
        </section>
    );

}
LoginForm.propTypes = {
    login: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    setAlert: PropTypes.func.isRequired,
    role: PropTypes.string
    //user: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    role: state.auth && state.auth.user ? state.auth.user.type : null
    //name: state.auth.user.name
})

export default connect(mapStateToProps, { login, authLogin, setAlert })(LoginForm)